import { createContext, useState, useMemo, useEffect } from "react";
import { createTheme } from "@mui/material/styles";

// color design tokens export
export const tokens = (mode) => ({
  ...(mode === "dark"
    ? {
      // #1e2746 dark
      //#181f39 darker
      
      //#1e2746 darker


        grey: {
          100: "#e0e0e0",
          200: "#c2c2c2",
          300: "#a3a3a3",
          400: "#858585",
          500: "#181f39",//dark for borders 
          600: "#1e2746",
          700: "#3d3d3d",
          800: "#fff",
          900: "#ffffff",//sidebar white color 
        },
        primary: {
          100: "#0fc1f3",//blue
          200: "#00b096",//green
          300: "#fff",
          400: "#1e2746",//darker blue
          500: "#181f39",//dark blue bg
          600: "#fff",
          700: "#ffffff",
          800: "#080b12",
          900: "#040509",
        },
        greenAccent: {
          100: "#dbf5ee",
          200: "#b7ebde",
          300: "#94e2cd",
          400: "#70d8bd",
          500: "#3CDFFF",
          600: "#fff",
          700: "#2e7c67",
          800: "#1e5245",
          900: "#181f39",//dark bliue
        },
        redAccent: {
          100: "#fff",//white
          200: "#fff",
          300: "#e99592",
          400: "#e2726e",
          500: "#e72e2e ",
          600: "#af3f3b",
          700: "#832f2c",
          800: "#58201e",
          900: "#00b096",
        },
        blueAccent: {
          100: "#1e2746",//darker blue 
          200: "#181f39",//dark blue 
          300: "#1e2746",//darker blue 
          400: "#1e2746",
          500: "#6870fa",
          600: "#535ac8",
          700: "#fff",
          800: "#2a2d64",
          900: "#fff",
        },
      }
    : {
        grey: {
          100: "#141414",
          200: "#292929",
          300: "#3d3d3d",
          400: "#0092a5",
          500: "#d3d3d3",//darker blue
          600: "#d3d3d3",//dark blue
          700: "#a3a3a3",
          800: "#6c757d", //subca5 name 
          900: "#000000",//sidebar blsck color 
        },
        primary: {
          100: "#0fc1f3",//blue
          200: "#00b096",//green
          300: "#4c5258", //Heading Grey
          400: "#ffffff", // manually changed white
          500: "#f7f8fa", //backgroundColor signup,dashbioard and sidebar
          600: "#4c5258", //typograpgy Color sub header
          700: "#0d6efd", //link color
          800: "#a1a4ab",
          900: "#d0d1d5",
        },
        greenAccent: {
          100: "#0f2922",
          200: "#1e5245",
          300: "#2e7c67",
          400: "#3da58a",
          500: "#4cceac",
          600: "#000000", //black
          700: "#94e2cd",
          800: "#b7ebde",
          900: "#ffffff", //black 
        },
        redAccent: {
          100: "#808080",//white 
          200: "#675c5c",//grey on search
          300: "#832f2c",
          400: "#af3f3b",
          500: "#db4f4a",
          600: "#e2726e",
          700: "#e99592",
          800: "#f1b9b7",
          900: "#ffffff",
        },
        blueAccent: {
          100: "#f7f8fa", //bg color light 
          200: "#fff",//bg white 
          300: "#fff",//bg white 
          400: "#f3f3f3",//hover sidebar 
          500: "#6870fa",
          600: "#868dfb",
          700: "#4c525d",
          800: "#c3c6fd",
          900: "#293445",
        },
      }),
});

// mui theme settings
export const themeSettings = (mode) => {
  const colors = tokens(mode);
  return {
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            // palette values for dark mode
            primary: {
              main: colors.primary[500],
            },
            secondary: {
              main: colors.greenAccent[500],
            },
            neutral: {
              dark: colors.grey[700],
              main: colors.grey[500],
              light: colors.grey[100],
            },
            background: {
              default: colors.primary[500],
            },
          }
        : {
            // palette values for light mode
            primary: {
              main: colors.primary[100],
            },
            secondary: {
              main: colors.greenAccent[500],
            },
            neutral: {
              dark: colors.grey[700],
              main: colors.grey[500],
              light: colors.grey[100],
            },
            background: {
              default: colors.primary[500],
            },
          }),
    },
    typography: {
      fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 20,
      },
      h5: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Source Sans Pro", "sans-serif"].join(","),
        fontSize: 14,
      },
    },
  };
};

// context for color mode
export const ColorModeContext = createContext({
  toggleColorMode: () => {},
  toggleRTL: () => {},//RTL
  untoggleRTL: () => {},//RTL Untoggle
  mode: "dark", // Add the mode state to the context
  isRTL: true,
});

export const useMode = () => {
  const savedMode = localStorage.getItem("colorMode");

  const [isRTL, setRTL] = useState(false);
  const initialMode = savedMode || "dark";
  const [mode, setMode] = useState(initialMode);
  // Update local storage whenever the mode changes
  useEffect(() => {
    localStorage.setItem("colorMode", mode);
  }, [mode]);
  // const colorMode = useMemo(
  //   () => ({
  //     toggleColorMode: () =>
  //       setMode((prev) => (prev === "light" ? "dark" : "light")),
  //   }),
  //   []
  // );

  // const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

  const toggleColorMode = () => setMode((prev) => (prev === "light" ? "dark" : "light"));
  const toggleRTL = () => setRTL(true);
  const untoggleRTL = () => setRTL(false);


  const colorMode = useMemo(() => ({
    toggleColorMode,
    toggleRTL,
    untoggleRTL,
  isRTL,
    mode, // Add the mode state to the context value
  }), [mode,isRTL]);

  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);


  return [theme, colorMode];
};
